package com.essntl.features.paymentlink.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.paymentlink.data")
class PaymentLinkModule
